import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadCcApprovalLevelById,
    setCcApprovalLevelEdit,
    setCcApprovalLevelReloadEdit,
    initCcApprovalLevel,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface ApprovalLevelEditProps {
    levelId: number
    module: number
}

const Edit = ({
    levelId,
    module,
}: ApprovalLevelEditProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const level = useSelector((state: StoreType) => state.ccApprovalLevel.levelEdit)
    const reloadEdit = useSelector((state: StoreType) => state.ccApprovalLevel.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcApprovalLevelReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcApprovalLevelReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (levelId === 0) {
            dispatch(setCcApprovalLevelEdit(initCcApprovalLevel))
            reload()
        } else {
            setLoadState(PENDING)
            LoadCcApprovalLevelById(levelId, userData.accountId, project.id).then((res) => {
                dispatch(setCcApprovalLevelEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!level) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{level.id ? `${lang.editApprovalLevel} #${level.id}` : lang.addResponse}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form level={level} module={module} />
                }
                {
                    reloadEdit
                    && <Form level={level} module={module} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
